import { SectionComponentLayout, ImageFullWidth, Image } from '@cbhq/cdx-components';
import { jsx } from 'react/jsx-runtime';
function GlobalMedia({
  media,
  altText,
  isFullWidth = true,
  hasSpacingTop = true,
  options
}) {
  return /*#__PURE__*/jsx(SectionComponentLayout, {
    hasSpacingHorizontal: false,
    hasSpacingTop: options?.hasSpacingTop !== undefined ? Boolean(options?.hasSpacingTop) : hasSpacingTop,
    children: options?.isFullWidth !== undefined ? options?.isFullWidth : isFullWidth ? /*#__PURE__*/jsx(ImageFullWidth, {
      src: media?.fields?.file?.url,
      altText: altText
    }) : /*#__PURE__*/jsx(Image, {
      src: media?.fields?.file?.url,
      alt: altText
    })
  });
}
export { GlobalMedia };
//# sourceMappingURL=GlobalMedia.js.map
